<template>
  <div class="settingsRow">
    <div class="label">
      <div class="name">{{ name }}</div>
      <p v-if="description || $slots.description" class="desc">
        <slot name="description">{{ description }}</slot>
      </p>
    </div>
    <div class="controls"><slot /></div>
  </div>
</template>

<script setup lang="ts">
// One setting: name + description on the left, its controls on the right.
defineProps<{ name: string; description?: string }>()
</script>

<style scoped>
.settingsRow {
  display: grid;
  grid-template-columns: minmax(200px, 300px) minmax(0, 1fr);
  gap: var(--space-6);
  padding: 20px var(--space-5);
}
.label { min-width: 0; }
.name { font-size: var(--fs-sm); font-weight: var(--fw-semibold); color: var(--color-text-primary); }
.desc {
  margin: var(--space-1) 0 0;
  max-width: 38ch;
  font-size: var(--fs-sm);
  line-height: var(--lh-normal);
  color: var(--color-text-secondary);
}
.desc :deep(a) { color: var(--color-accent); font-weight: var(--fw-medium); text-decoration: none; }
.desc :deep(a:hover) { text-decoration: underline; }
.controls {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--space-3);
}

@container (max-width: 680px) {
  .settingsRow { grid-template-columns: minmax(0, 1fr); gap: var(--space-3); padding: var(--space-4); }
  .desc { max-width: none; }
}
</style>
